"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var TranslateIcon = /*#__PURE__*/function (_React$Component) {
  function TranslateIcon() {
    _classCallCheck(this, TranslateIcon);
    return _callSuper(this, TranslateIcon, arguments);
  }
  _inherits(TranslateIcon, _React$Component);
  return _createClass(TranslateIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "translate-icon icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 200 200",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        id: "Page-1",
        stroke: "none",
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        id: "badge_translationmaster"
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        id: "background",
        fill: "#6B6A6A",
        cx: "100",
        cy: "100",
        r: "99.4"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(104.000000, 157.000000)",
        fill: "#FFFFFF",
        opacity: "0.7"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M1.4,1.6 C1.5,1.7 1.6,1.9 1.8,2 C1.8,2 1.8,2 1.8,2 C1.7,1.9 1.6,1.8 1.4,1.6 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M1.4,1.5 C1.3,1.4 1.2,1.2 1.2,1 C1.2,1.2 1.3,1.4 1.4,1.5 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M3.2,2.6 C3.2,2.6 3.1,2.6 3.1,2.6 C2.9,2.6 2.7,2.5 2.5,2.4 C2.7,2.5 2.9,2.6 3.2,2.6 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M1.9,2.1 C2,2.2 2.2,2.3 2.3,2.4 C2.2,2.3 2,2.2 1.9,2.1 Z",
        id: "Path"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(98.000000, 136.000000)",
        fill: "#FFFFFF"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M26.8,3.8 L0.3,3.8 L7.2,22.1 C7.5,22.9 8.2,23.5 9.1,23.7 C9.2,23.7 9.4,23.7 9.5,23.7 C10.2,23.7 10.9,23.4 11.4,22.9 L28.8,3 C28.8,2.9 28.9,2.9 28.9,2.8 C28.4,3.4 27.7,3.8 26.8,3.8 Z",
        id: "Path",
        opacity: "0.8"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M29.3,0.9 C29.3,1 29.3,1.1 29.3,1.2 C29.3,1.1 29.3,1 29.3,0.9 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M29.2,0.5 C29.2,0.6 29.2,0.6 29.3,0.7 C29.2,0.7 29.2,0.6 29.2,0.5 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M29.3,1.9 C29.3,2 29.2,2.1 29.2,2.2 C29.2,2 29.2,2 29.3,1.9 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M29.3,1.7 C29.3,1.6 29.3,1.4 29.3,1.3 C29.3,1.4 29.3,1.6 29.3,1.7 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M28.9,2.6 C29,2.5 29,2.4 29.1,2.2 C29.1,2.4 29,2.5 28.9,2.6 Z",
        id: "Path"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(40.000000, 40.000000)",
        fill: "#FFFFFF"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M87.2,96.5 L54.9,2.1 C54.6,1.1 53.6,0.4 52.5,0.4 L12.8,0.4 C5.9,0.4 0.4,6 0.4,12.8 L0.4,87.3 C0.4,94.2 6,99.7 12.8,99.7 L84.9,99.7 C86.3,99.7 87.4,98.6 87.4,97.2 C87.3,97 87.3,96.7 87.2,96.5 Z M48.4,69.8 C48.1,69.9 47.8,69.9 47.6,69.9 C46.5,69.9 45.6,69.2 45.3,68.3 L40.5,55 C40.4,55 40.3,55 40.1,55 L30.2,55 C30.1,55 30,55 29.8,55 L25.1,68.3 C24.6,69.6 23.1,70.2 21.9,69.7 C20.7,69.2 20.1,67.9 20.5,66.7 L32.9,31.9 C33.5,30.6 35,30.1 36.3,30.7 C36.8,31 37.3,31.4 37.5,31.9 L49.9,66.7 C50.4,67.9 49.7,69.3 48.4,69.8 Z",
        id: "Shape"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "31.6 50.1 38.7 50.1 35.2 40.1"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(101.000000, 60.000000)",
        fill: "#FFFFFF",
        opacity: "0.7"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M46.2,0.2 L0.1,0.2 L10.4,30.2 C10.7,30.1 11.1,30 11.4,30 L23.8,30 L23.8,27.5 C23.8,26.1 24.9,25 26.3,25 C27.7,25 28.8,26.1 28.8,27.5 L28.8,30 L46.2,30 C47.6,30 48.7,31.1 48.7,32.5 C48.7,33.9 47.6,35 46.2,35 L40.9,35 C39.7,40.1 35.5,48.1 29.9,55.1 C33.9,59.3 38.1,63.4 40.4,65.5 C41.4,66.4 41.5,68 40.6,69 C40.1,69.5 39.5,69.8 38.7,69.8 C38.1,69.8 37.5,69.6 37,69.1 C36.1,68.2 31.3,63.8 26.5,58.8 C24.9,60.4 23.3,61.9 21.6,63.3 L26.1,76.4 C26.1,76.4 26.1,76.4 26.1,76.5 C26.1,76.6 26.1,76.6 26.2,76.7 C26.2,76.8 26.2,76.8 26.2,76.9 C26.2,77 26.2,77.1 26.2,77.2 C26.2,77.2 26.2,77.3 26.2,77.3 C26.2,77.3 26.2,77.3 26.2,77.3 C26.2,77.4 26.2,77.6 26.2,77.7 C26.2,77.8 26.2,77.8 26.2,77.9 C26.2,78 26.1,78.1 26.1,78.2 C26.1,78.2 26.1,78.3 26,78.3 C25.9,78.4 25.9,78.5 25.8,78.7 C25.8,78.7 25.7,78.8 25.7,78.8 C25.7,78.9 25.6,78.9 25.6,79 L8.2,98.9 C7.7,99.4 7,99.7 6.3,99.7 L46.1,99.7 C53,99.7 58.5,94.1 58.5,87.3 L58.5,12.7 C58.6,5.8 53.1,0.2 46.2,0.2 Z",
        id: "Path"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M17.9,42.7 C19.2,42.2 20.6,42.8 21.1,44.1 C21.8,45.9 23.9,48.6 26.5,51.5 C31.2,45.6 34.6,39 35.8,35.1 L12,35.1 L20,58.4 C21.1,57.4 22.2,56.4 23.3,55.3 C20.2,51.8 17.6,48.4 16.6,46 C16.1,44.6 16.7,43.2 17.9,42.7 Z",
        id: "Path"
      }))))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _icon_wrapper["default"])(TranslateIcon);